import { jsx as _jsx } from "react/jsx-runtime";
import { ReplaceContent } from '../../../storybook';
//Components
import { ContainerWaveComponent as Story } from '../container-wave.component';
//Types
import { IconPositionType, RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
import { argtypes } from './argtypes';
const meta = {
    title: 'Zinia 2.0/Elements/WaveContainer',
    component: Story,
    tags: ['autodocs'],
    argTypes: argtypes(),
    parameters: {
        layout: 'fullscreen',
    },
};
export default meta;
export const WaveContainer = {
    args: {
        testId: 'container-wave',
        backButton: {
            children: '',
            iconPosition: IconPositionType.LEFT,
            iconConfiguration: {
                icon: 'icon_chevron_left',
                height: '24px',
                width: '24px',
            },
            size: RELOADED_VARIANTS.ButtonSizeType.EXTRA_SMALL,
            type: RELOADED_VARIANTS.ButtonVariantType.MAIN_SECTION_HEADER_GHOST,
            onClick: () => alert('clicked!'),
        },
        header: {
            illustration: 'logo_brand_adaptive-converted',
            logo: `url(https://t3.ftcdn.net/jpg/04/21/50/96/360_F_421509616_AW4LfRfbYST8T2ZT9gFGxGWfrCwr4qm4.jpg)`,
            backgroundImage: `url(https://t3.ftcdn.net/jpg/04/21/50/96/360_F_421509616_AW4LfRfbYST8T2ZT9gFGxGWfrCwr4qm4.jpg)`,
        },
        footer: {
            firstButton: {
                children: 'Button',
                size: RELOADED_VARIANTS.ButtonSizeType.LARGE,
                type: RELOADED_VARIANTS.ButtonVariantType.PRIMARY,
                onClick: () => alert('clicked!'),
            },
            secondButton: {
                children: 'Button',
                size: RELOADED_VARIANTS.ButtonSizeType.LARGE,
                type: RELOADED_VARIANTS.ButtonVariantType.SECONDARY_GHOST,
                onClick: () => alert('clicked!'),
            },
        },
        children: _jsx(ReplaceContent, {}),
    },
};
//# sourceMappingURL=container-wave.stories.js.map